import * as React from "react";
const SvgFood = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 2.75a9.25 9.25 0 0 0 0 18.5c.968 0 1.9-.148 2.775-.423a.75.75 0 1 1 .45 1.43c-1.02.32-2.103.493-3.225.493-5.937 0-10.75-4.813-10.75-10.75S13.063 1.25 19 1.25c1.122 0 2.206.172 3.225.492a.75.75 0 1 1-.45 1.431A9.246 9.246 0 0 0 19 2.75Zm-17 .5a.75.75 0 0 1 .75.75v3.75h1V4a.75.75 0 0 1 1.5 0v3.75h1V4a.75.75 0 0 1 1.5 0v4.5a3.251 3.251 0 0 1-2.5 3.163v9.627a.75.75 0 0 1-1.5 0v-9.627A3.251 3.251 0 0 1 1.25 8.5V4A.75.75 0 0 1 2 3.25Zm.918 6a1.75 1.75 0 0 0 3.163 0H2.918Zm8.549.586a.75.75 0 1 0 1.405.524 6.722 6.722 0 0 1 1.594-2.45 6.725 6.725 0 0 1 2.318-1.493.75.75 0 1 0-.535-1.401 8.226 8.226 0 0 0-2.835 1.823 8.22 8.22 0 0 0-1.947 2.997Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgFood;
